import React, { FunctionComponent, useState } from 'react'
import FortuneWheelWrapper from './FortuneWheel/FortuneWheelWrapper'
import { Modal } from 'react-bootstrap'
import WheelButton from './cta/WheelButton'
import LotteryConfigurationResponse, {
  LotteryType,
} from '@tootsweet/model/lottery/LotteryConfigurationResponse'
import { tt } from '../i18n'
import ScratchCardChristmas from '../app/05_ScratchCard/ScratchCardChristmas'
import LotteryV2StepType from '@tootsweet/model/lottery/LotteryV2StepType'
import AdventCalendar from '../app/06_AdventCalendar/AdventCalendar'
import ScratchCard from '../app/05_ScratchCard/ScratchCard'
import SlotMachine from '../app/09_SlotMachine/SlotMachine'
import WheelAnalyticsManager from '../analytics/WheelAnalyticsManager'
import { renderTitle } from '../app/helpers/renderTitle'
import GiftMachine from '../app/16_GiftMachine/GiftMachine'

interface Props {
  wheelLabels: string[]
  prize: { index: number; win: boolean; label: string } | null
  renderModalBody: (close: () => void) => any
  loading: boolean
  finalPlaceName: string
  lotteryConfig?: LotteryConfigurationResponse
  modalClass?: string
  stepType: LotteryV2StepType
}

interface State {
  changed: boolean
  showModal: boolean
}

const GenericGameStep: FunctionComponent<Props> = (props) => {
  const [changed, setChanged] = useState(false)
  const [modal, setModal] = useState(false)

  const renderBackgroundGame = () => {
    const { lotteryConfig, finalPlaceName } = props

    if (!lotteryConfig) {
      return null
    }

    switch (lotteryConfig.type) {
      case LotteryType.GiftMachine:
        return (
          <GiftMachine
            finalPlaceName={finalPlaceName}
            isPlayStep={false}
            onCTAClicked={showModal}
          />
        )

      case LotteryType.SlotMachine:
        return (
          <SlotMachine
            finalPlaceName={finalPlaceName}
            isPlayStep={false}
            onCTAClicked={showModal}
          />
        )

      case LotteryType.Tombola:
      case LotteryType.Wheel:
        return (
          <>
            <FortuneWheelWrapper
              forceHideCTA={true}
              finalPlaceName={finalPlaceName}
            />

            <WheelButton
              text={tt('spin_the_wheel')}
              isFixedBottom={true}
              onClick={showModal}
            />
          </>
        )

      case LotteryType.AdventCalendar:
        return (
          <AdventCalendar
            finalPlaceName={finalPlaceName}
            onUserStartedScratching={showModal}
            play={false}
          />
        )

      case LotteryType.ScratchCardChristmas:
        return (
          <ScratchCardChristmas
            finalPlaceName={finalPlaceName}
            onUserStartedScratching={showModal}
            gameStepType={LotteryV2StepType.ScratchCardChristmas}
          />
        )

      case LotteryType.ScratchCard:
        return (
          <ScratchCard
            finalPlaceName={finalPlaceName}
            onUserStartedScratching={showModal}
            gameStepType={LotteryV2StepType.ScratchCard}
            renderTitle={renderTitle}
          />
        )

      // case LotteryType.ScratchCard:
      // default:
    }

    return null
  }

  const showModal = () => {
    WheelAnalyticsManager.logEvent(
      `${(props.stepType || '').toLowerCase()}_modal`
    )
    setModal(true)
  }

  const closeModal = () => {
    setModal(false)
  }

  const { lotteryConfig } = props

  let displayCloseButton = false

  if (lotteryConfig) {
    switch (lotteryConfig.type) {
      case LotteryType.ScratchCard:
      case LotteryType.ScratchCardChristmas:
        displayCloseButton = false
        break
      case LotteryType.Quizz:
      case LotteryType.Tombola:
      case LotteryType.Wheel:
        displayCloseButton = true
        break
    }
  }

  return (
    <>
      {renderBackgroundGame()}

      <Modal
        show={modal}
        onHide={closeModal}
        centered={true}
        backdrop="static"
        className={props.modalClass}
      >
        <Modal.Body>
          <div className="w-modal">
            <div className="container">
              {displayCloseButton && (
                <i className="fas fa-times modal-close" onClick={closeModal} />
              )}
              {props.renderModalBody(closeModal)}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default GenericGameStep
